import React from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import {
  DataTable,
  Field,
  CurrencyField,
  DateTimeField,
  PaymentsDataField,
  BilledField,
} from '../../../commons/DataTable';
import IAFCustomCheckboxes from '../../../commons/Checkboxes/IAFCustomCheckboxes';
import { useAuth } from '../../../commons/Auth';
import CommercialBilledField from '../../../commons/DataTable/CommercialBilledField';
import { USER_ADMIN_TYPES } from '../../../App';

function RoyaltyTableBackoffice({
  dataTable,
  data,
  total = 0,
  query = {},
  onFilter,
  isLoading,
  bottomRow,
  showEmptyTableMessage,
  truncateTable,
  onSelectChange,
  allowedRoles = [],
}) {
  const [t] = useTranslation('COMMON');
  const [{ newIsAdmin, newUserType = '' }] = useAuth();
  const { offset, limit } = query;

  const onCheck = (report) => {
    if (!allowedRoles.includes('superadmin')) {
      return;
    }
    onSelectChange(report);
  };

  return (
    <DataTable
      offset={offset}
      limit={limit}
      total={total}
      dataTable={dataTable}
      data={data}
      isLoading={isLoading}
      loadingText={t('LOADING')}
      emptyText={t('NO_DATA')}
      onFilter={onFilter}
      bottomRow={bottomRow}
      showEmptyTableMessage={showEmptyTableMessage}
    >
      {!truncateTable &&
        (newIsAdmin ? (
          <IAFCustomCheckboxes
            onSelectChange={onCheck}
            onClick={(e) => e.stopPropagation()}
          />
        ) : (
          <></>
        ))}
      {!truncateTable && (
        <Field
          title="Nome Fornitore"
          source="supplier.businessName"
          className="text-left"
        />
      )}
      {!truncateTable && <Field title="Numero fattura" source="number" />}
      {!truncateTable && (
        <DateTimeField title="Data dattura" source="date" format="DD/MM/YYYY" />
      )}
      {!truncateTable && (
        <DateTimeField
          title="Mese Rend."
          source="accountability"
          format="MM/YYYY"
        />
      )}
      {!truncateTable && (
        <Field
          title="Amministratore di Condominio"
          source="admin.businessName"
        />
      )}
      <CurrencyField
        title="Imponibile"
        source="net"
        className="txt-table-right"
      />
      <CurrencyField
        title="Importo da Incassare"
        source="gross"
        className="txt-table-right"
      />
      <PaymentsDataField title="Pagato" source="payments" type="total" />
    </DataTable>
  );
}

export default withRouter(RoyaltyTableBackoffice);
